import { Comment } from './types';

// Mesma origem em prod (behavior /api/* no CloudFront → Lambda). Em dev, o
// setupProxy.js redireciona /api → http://localhost:4000. Override opcional via env.
const BASE = process.env.REACT_APP_COMMENTS_API || '/api';

async function req(path: string, opts?: RequestInit): Promise<any> {
  const res = await fetch(BASE + path, {
    headers: { 'Content-Type': 'application/json' },
    ...opts,
  });
  if (!res.ok) throw new Error(`comments-api ${res.status}`);
  if (res.status === 204) return null;
  return res.json();
}

export interface NewCommentPayload {
  thread_id?: string;
  route: string;
  anchor_selector: string | null;
  anchor_offset_x: number | null;
  anchor_offset_y: number | null;
  fallback_x: number;
  fallback_y: number;
  author_name: string;
  body: string;
}

export const api = {
  list: (route: string): Promise<Comment[]> =>
    req(`/comments?route=${encodeURIComponent(route)}`).then((d) => d.comments),
  all: (): Promise<Comment[]> => req(`/comments/all`).then((d) => d.comments),
  create: (payload: NewCommentPayload): Promise<Comment> =>
    req(`/comments`, { method: 'POST', body: JSON.stringify(payload) }).then((d) => d.comment),
  setResolved: (id: string, resolved: boolean): Promise<void> =>
    req(`/comments/${encodeURIComponent(id)}`, {
      method: 'PATCH',
      body: JSON.stringify({ resolved }),
    }),
  // author_name enviado para a checagem de autoria no servidor.
  remove: (id: string, authorName: string): Promise<void> =>
    req(`/comments/${encodeURIComponent(id)}`, {
      method: 'DELETE',
      body: JSON.stringify({ author_name: authorName }),
    }),
};
